import { FiDialogsContainerBase } from '@fi-shared/fi-dialogs/fi-dialogs-container-base';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { MatDialogRef } from '@angular/material/dialog';
import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'fi-add-quick-selection-dialog-component',
    template: `
        <div class="text-wrapper">
            <p class="paragraph-marging">{{ 'new_quick_selection_dialog_p_1' | fiAppText }}</p>
            <p>{{ 'new_quick_selection_dialog_p_2' | fiAppText }}</p>
        </div>
    `,
    styleUrls: ['./add-quick-selection-dialog-component.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AddQuickSelectionDialogComponentComponent extends FiDialogsContentBase<void, void> {
    constructor(
        private matDialogRef: MatDialogRef<FiDialogsContainerBase<void, void>>,
        injector: Injector,
    ) {
        super(matDialogRef, undefined, injector);
    }
}
